
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './index.css';

import Root from './root';
import AuthPage from './routes/auth';
import HomePage from './routes/home';
import WorkoutTypesPage from './routes/workout-types';
import ClientsPage from './routes/clients';
import ClientDetailsPage from './routes/client.$id';
import SchedulePage from './routes/schedule';
import CalendarPage from './routes/calendar';
import UsersPage from './routes/users';
import GymSettingsPage from './routes/gym-settings';
import DashboardPage from './routes/dashboard';
import NotesPage from './routes/notes';
import NotFound from '@/pages/NotFound';

console.log('Creating router...');

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'auth',
        element: <AuthPage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'workout-types',
        element: <WorkoutTypesPage />,
      },
      {
        path: 'clients',
        element: <ClientsPage />,
      },
      {
        path: 'client/:id',
        element: <ClientDetailsPage />,
      },
      {
        path: 'schedule',
        element: <SchedulePage />,
      },
      {
        path: 'calendar',
        element: <CalendarPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'gym-settings',
        element: <GymSettingsPage />,
      },
      {
        path: 'notes',
        element: <NotesPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

console.log('Router created, finding root element...');

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
  throw new Error('Root element not found');
}

console.log('Root element found, rendering app...');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

console.log('App render initiated...');
